import Conditional from 'decorators/conditional';
import Desktop from './index.desktop';
import Mobile from './index.mobile';
import Tablet from './index.tablet';

export default Conditional({
  mobile: Mobile,
  tablet: Tablet,
  desktop: Desktop,
});
